var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgManArm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "92px",
    height: "59px",
    viewBox: "0 0 92 59",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ManArm"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.5538698,0.763136815 C92.2692811,1.62519283 92.1057585,2.88497233 91.1961642,3.56071613 L87.5134784,6.28398205 C88.5333487,8.27338384 87.9049918,10.7954637 86.0480251,11.9984248 L79.3114897,16.3553027 C77.438723,17.5684992 74.9735506,17.0163513 73.7362895,15.1449107 L73.6204489,14.9586693 C72.4171439,12.9363852 73.0187964,10.2544367 74.9519749,9.00107414 L81.6885103,4.64419619 C82.3291777,4.22950718 83.0391745,4.02119037 83.7456231,4.00153786 L88.590023,0.421403524 C89.5098375,-0.254340271 90.8384585,-0.100849895 91.5538698,0.763136815 Z",
    id: "Path",
    fill: "#ED5353"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.26854872,14.7771232 C5.26854872,14.7771232 34.2412447,39.5332669 41.8193636,33.3425797 C49.3974825,27.1518925 72.2253104,10 72.2253104,10 L82,20.083301 C82,20.083301 48.4657548,59.710956 37.4540648,58.9902883 C26.4423749,58.2696205 0,41.0713634 0,41.0713634 L2,15 L5.26854872,14.7771232 Z",
    id: "Fill-208",
    fill: "#B1BCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83,20.4324016 C83,20.4324016 49.0683921,59.7045784 37.9262196,58.9903754 C30.3870921,58.5069149 15.7102932,50.5527908 7,45.4554788 L11.5709671,37.9618408 C11.5709671,37.9618408 29.8457801,50.7965188 37.8004501,51.8873016 C44.787198,52.8442338 48.0411068,51.5027308 81.6115046,19 L83,20.4324016 Z",
    id: "Fill-209",
    fill: "#8A9EBD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManArm);
export default __webpack_public_path__ + "static/media/ManArm.1fb6ae04cbcbb49c7b37f1130d7d169e.svg";
export { ForwardRef as ReactComponent };